/**
 * Created by lihanying on 2017/7/5.
 */

export const GETCLUBLIST = 'GETCLUBLIST'


// WEBPACK FOOTER //
// ./src/containers/Home/constants.js